Oskari.bundle_manager.registerDynamic('admin-permissions', function() {return import(/* webpackChunkName: "chunk_admin-permissions" */ 'oskari-loader!oskari-frontend/packages/admin/bundle/admin-permissions/bundle.js');});
